/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createGlobalConfiguration } from '../fn/global-configurations/create-global-configuration';
import { CreateGlobalConfiguration$Params } from '../fn/global-configurations/create-global-configuration';
import { deleteGlobalConfiguration } from '../fn/global-configurations/delete-global-configuration';
import { DeleteGlobalConfiguration$Params } from '../fn/global-configurations/delete-global-configuration';
import { getGlobalConfiguration } from '../fn/global-configurations/get-global-configuration';
import { GetGlobalConfiguration$Params } from '../fn/global-configurations/get-global-configuration';
import { GlobalConfigurationDto } from '../models/global-configuration-dto';
import { GlobalConfigurationDtoPage } from '../models/global-configuration-dto-page';
import { listGlobalConfigurations } from '../fn/global-configurations/list-global-configurations';
import { ListGlobalConfigurations$Params } from '../fn/global-configurations/list-global-configurations';
import { updateGlobalConfiguration } from '../fn/global-configurations/update-global-configuration';
import { UpdateGlobalConfiguration$Params } from '../fn/global-configurations/update-global-configuration';

@Injectable({ providedIn: 'root' })
export class GlobalConfigurationsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listGlobalConfigurations()` */
  static readonly ListGlobalConfigurationsPath = '/v0/globalConfigurations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listGlobalConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGlobalConfigurations$Response(params?: ListGlobalConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalConfigurationDtoPage>> {
    return listGlobalConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listGlobalConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listGlobalConfigurations(params?: ListGlobalConfigurations$Params, context?: HttpContext): Observable<GlobalConfigurationDtoPage> {
    return this.listGlobalConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<GlobalConfigurationDtoPage>): GlobalConfigurationDtoPage => r.body)
    );
  }

  /** Path part for operation `getGlobalConfiguration()` */
  static readonly GetGlobalConfigurationPath = '/v0/globalConfigurations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGlobalConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGlobalConfiguration$Response(params: GetGlobalConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalConfigurationDto>> {
    return getGlobalConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGlobalConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGlobalConfiguration(params: GetGlobalConfiguration$Params, context?: HttpContext): Observable<GlobalConfigurationDto> {
    return this.getGlobalConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<GlobalConfigurationDto>): GlobalConfigurationDto => r.body)
    );
  }

  /** Path part for operation `updateGlobalConfiguration()` */
  static readonly UpdateGlobalConfigurationPath = '/v0/globalConfigurations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateGlobalConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGlobalConfiguration$Response(params: UpdateGlobalConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateGlobalConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateGlobalConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateGlobalConfiguration(params: UpdateGlobalConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.updateGlobalConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createGlobalConfiguration()` */
  static readonly CreateGlobalConfigurationPath = '/v0/globalConfigurations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createGlobalConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGlobalConfiguration$Response(params: CreateGlobalConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<GlobalConfigurationDto>> {
    return createGlobalConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createGlobalConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createGlobalConfiguration(params: CreateGlobalConfiguration$Params, context?: HttpContext): Observable<GlobalConfigurationDto> {
    return this.createGlobalConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<GlobalConfigurationDto>): GlobalConfigurationDto => r.body)
    );
  }

  /** Path part for operation `deleteGlobalConfiguration()` */
  static readonly DeleteGlobalConfigurationPath = '/v0/globalConfigurations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteGlobalConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGlobalConfiguration$Response(params: DeleteGlobalConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteGlobalConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteGlobalConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteGlobalConfiguration(params: DeleteGlobalConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.deleteGlobalConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
